module.exports = __webpack_public_path__ + "images/matt_barlin.jpg?v=ea9a72b161115c4930077eb3deb716db";